<template>
  <div>
    <ag-grid-vue :style="{width: '100%', height: height + 'px'}" class='ag-theme-balham-dark'
                 :gridOptions='gridOptions'
                 :rowData="records"
                 :suppressRowClickSelection="true">
    </ag-grid-vue>
  </div>
</template>
<script>
import {AgGridVue} from 'ag-grid-vue'
import { mapGetters } from 'vuex'
import {DefaultGridOptions} from "@/default_table_settings"
import {applyGridPersistence} from "@/grid_persistence"
import moment from 'moment'
import iziToast from 'izitoast'

export default {
  props: {
    records: Array,
    server: String,
    username: String,
    height: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      gridOptions: null,
      showToolPanel: false,
      modalTitle: ''
    }
  },
  components: {
    'ag-grid-vue': AgGridVue
  },
  computed: mapGetters({
    sharedIPs: 'sharedIPs'
  }),
  methods: {
    createRowData () {
      return this.records
    },
    createColumnDefs () {
      let columns = [
        {
          headerName: 'IP',
          field: 'ip',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Agent',
          field: 'agent',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'MAC',
          field: 'mac'
        },
        {
          headerName: 'Date',
          field: 'date',
          sort: 'desc',
          sortable: true,
          filter: 'agDateColumnFilter',
          cellRenderer: params => this.formatDateDisplay(params.value),
          tooltipValueGetter: params => {
            if (!params.value) return '';
            const m = moment(params.value);
            return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`;
          }
        },
        {
          headerName: 'Location',
          field: 'location',
          filter: 'agSetColumnFilter',
          valueGetter: function (value) {
            return value.data.location.location
          },
          cellRenderer: function (params) {
            return '<i class="flag-icon flag-icon-' + params.data.location.iso_code.toLowerCase() + '"></i> ' + params.value
          }
        }
      ]
      if (!this.hasPermission(this.UserMacView)) {
        columns.splice(2, 1)
      }
      return columns
    },
    formatMinutes (minutes) {
      let h = Math.floor(minutes / 60)
      let m = minutes % 60
      if (h <= 0) {
        return m + 'm'
      } else {
        return h + 'h'
      }
    },
    formatPrice (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    confirmBanIP(ip) {
      let self = this
      iziToast.question({
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: 'once',
        id: 'question',
        zindex: 999,
        title: 'Ban IP?',
        message: 'Are you sure you want to ban IP <b>' + ip + '</b>?',
        position: 'center',
        buttons: [
          ['<button><b>YES</b></button>', function (instance, toast) {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            self.emit('banIP', { ip: ip, username: self.username });
          }, true],
          ['<button>NO</button>', function (instance, toast) {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          }]
        ]
      });
    },
    confirmBanMAC(mac) {
      let self = this
      iziToast.question({
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: 'once',
        id: 'question',
        zindex: 999,
        title: 'Ban MAC?',
        message: 'Are you sure you want to ban MAC <b>' + mac + '</b>?',
        position: 'center',
        buttons: [
          ['<button><b>YES</b></button>', function (instance, toast) {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            self.emit('banMAC', { mac: mac, username: self.username });
          }, true],
          ['<button>NO</button>', function (instance, toast) {
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          }]
        ]
      });
    },
    getContextMenuItems: function getContextMenuItems (params) {
      let self = this
      let menu = [
        'copy',
        'copyWithHeaders',
        'separator',
        {
          name: ' Check IP',
          icon: '<i class="fa fa-globe"/>',
          action: function () {
            let win = window.open('https://whatismyipaddress.com/ip/' + params.node.data.ip, '_blank')
            win.focus()
          }
        },
        {
          name: ' Shared IP',
          icon: '<i class="fa fa-share-alt"/>',
          action: function () {
            self.emit('getSharedIPs', {'ip': params.node.data.ip, 'server': self.server})
            self.$root.$emit('show-shared-modal', {
              title: 'Shared IP: ' + params.node.data.ip,
              server: self.server
            });
          }
        },
        'separator'
      ]

      if (this.hasPermission(this.UserMacView)) {
        menu.push({
          name: ' Shared MAC',
          icon: '<i class="fa fa-share-alt"/>',
          action: function () {
            self.emit('getSharedMACs', {'mac': params.node.data.mac, 'server': self.server})
            self.$root.$emit('show-shared-modal', {
              title: 'Shared MAC: ' + params.node.data.mac,
              server: self.server
            });
          }
        })
      }

      let securitySubMenu = []

      if (this.hasPermission(this.BanIP)) {
        securitySubMenu.push({
          name: ' Ban IP',
          icon: '<i class="fa fa-map-marker"/>',
          action: function () {
            self.confirmBanIP(params.node.data.ip)
          }
        })
      }

      if (this.hasPermission(this.UserBanMac)) {
        securitySubMenu.push({
          name: ' Ban MAC',
          icon: '<i class="fa fa-address-card-o"/>',
          action: function () {
            self.confirmBanMAC(params.node.data.mac)
          }
        })
      }

      if (securitySubMenu.length > 0) {
        menu.push({
          name: ' Security',
          icon: '<i class="fa fa-shield text-danger"/>',
          subMenu: securitySubMenu
        })
      }

      menu.push('separator')
      menu.push('export')

      return menu
    },
    onGridSizeChanged () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  },
  beforeMount () {
    this.gridOptions = Object.assign({}, DefaultGridOptions, {
      suppressRowClickSelection: true,
      rowSelection: 'multiple',
      sidebar: true,
      getContextMenuItems: this.getContextMenuItems
    })
    applyGridPersistence(this.gridOptions, 'ip-history-grid')
    this.gridOptions.rowData = this.createRowData()
    this.gridOptions.columnDefs = this.createColumnDefs()
  },
  mounted () {
  }
}
</script>

<style>
</style>
